import { NSLabel } from 'bricks';
import NSInputNumberStepper from 'bricks/NSInputNumberStepper/NSInputNumberStepper';
import RenderIf from 'components/RenderIf/RenderIf';
import { IPatchPermanentDebt, IPermanentDebtInfo } from 'views/ProFormaTable/types';
import InterestOnlyPeriodStepper from '../InterestOnlyPeriodStepper/InterestOnlyPeriodStepper';

export interface IPermanentDebtInputSteppersProps {
    permanentDebtInfo: IPermanentDebtInfo;
    saleMonth: number;
    onUpdate: (keyValues: Partial<IPatchPermanentDebt>) => void;
}

const PermanentDebtInputSteppers: React.FC<IPermanentDebtInputSteppersProps> = ({
    permanentDebtInfo,
    saleMonth,
    onUpdate,
}) => {
    return (
        <>
            <div className="d-flex align-items-center mt-2">
                <NSLabel className="pl-0 col-5 my-auto font-weight-normal text-dark text-nowrap">Interest-only period</NSLabel>
                <InterestOnlyPeriodStepper
                    loanFundingMonth={permanentDebtInfo.loanFundingMonth ?? 0}
                    saleMonth={saleMonth}
                    value={permanentDebtInfo.interestOnlyPeriodMonths ?? null}
                    onChange={(months) => onUpdate({
                        interestOnlyPeriodMonths: months,
                    })}
                    inputGroupClassName="ProFormaPermanentDebt__input-width"
                />
            </div>

            <RenderIf isTrue={permanentDebtInfo.interestOnlyPeriodMonths !== null}>
                <div className="d-flex align-items-center mt-2">
                    <NSLabel className="pl-0 col-5 font-weight-normal text-dark text-nowrap">Amortization</NSLabel>
                    <NSInputNumberStepper
                        name="amortizationInYears"
                        value={permanentDebtInfo.amortizationInYears || null}
                        onChange={(value: number) => onUpdate({ amortizationInYears: value })}
                        min={0}
                        step={1}
                        customSuffix="years"
                        inputGroupClassName="ProFormaPermanentDebt__input-width"
                    />
                </div>
            </RenderIf>
            <div className="d-flex align-items-center mt-2">
                <NSLabel className="pl-0 col-5 font-weight-normal text-dark text-nowrap">APR</NSLabel>
                <NSInputNumberStepper
                    name="annualPercentageRate"
                    value={permanentDebtInfo.annualPercentageRate || null}
                    onChange={(value: number) => onUpdate({ annualPercentageRate: value })}
                    min={0}
                    step={0.1}
                    max={100}
                    percentage
                    inputGroupClassName="ProFormaPermanentDebt__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2">
                <NSLabel className="pl-0 col-5 font-weight-normal text-dark text-nowrap">Fees & closing costs</NSLabel>
                <NSInputNumberStepper
                    name="feesAndClosingCostsPercentage"
                    value={permanentDebtInfo.feesAndClosingCostsPercentage || null}
                    onChange={(value: number) => onUpdate({ feesAndClosingCostsPercentage: value })}
                    min={0}
                    step={0.1}
                    max={100}
                    percentage
                    inputGroupClassName="ProFormaPermanentDebt__input-width"
                />
            </div>
        </>
    );
};

export default PermanentDebtInputSteppers;
